import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-confetti',
    templateUrl: './confetti.component.html',
    styleUrl: './confetti.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfettiComponent {

}
